<template>
  <v-app>
    <v-main>
      <v-container center>
        <v-row justify="center" class="my-12">
          <v-col justify="center">
            <Pending v-model="articlePromise" v-slot="{ result: article }">
              <FullArticleView :article="article" class="mx-auto" style="max-width:900px;" />
            </Pending>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Pending from '../../../gfqg-website/src/components/Pending'
import FullArticleView from '../../../gfqg-website/src/components/article/FullArticleView'
import Article from '../../../gfqg-website/src/article'

export default {
  name: 'App',
  components: { FullArticleView, Pending },
  data: () => ({
    articlePromise: Article.byId('25b5dcb1-a9bc-4cb0-aaae-1b5afd610519'),
  }),
}
</script>
